import React from 'react';

import {makeToolTipUrl} from "utils/DBUtils";

export const PersonalityQuizHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on top.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/1.CMS-PersonalityQuiz-headline.png')} width="100%"/>
  </div>
);

export const PersonalityQuizIntroCopyToolTip = (props) => (
  <div>
    Copy that introduces the quiz.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/2.CMS-PersonalityQuiz-intro.png')} width="100%"/>
  </div>
);

export const PersonalityQuizDefaultAnswerButtonBackgroundColorToolTip = (props) => (
  <div>
    Color on the quiz answer buttons.  Will prefill with brand theme color in sponsored breaks and default dark blue for editorial.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/3.CMS-PersonalityQuiz-answer-button-bkgd-color.png')} width="100%"/>
  </div>
);

export const PersonalityQuizAnswerButtonTextColorToolTip = (props) => (
  <div>
    Color of the text on the quiz answer buttons.  Will prefill with brand theme color in sponsored breaks.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/4.CMS-PersonalityQuiz-answer-button-text.png')} width="100%"/>
  </div>
);

export const PersonalityQuizAnswerButtonBorderColorToolTip = (props) => (
  <div>
    Color of the border on the quiz answer buttons.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/5.CMS-PersonalityQuiz-answer-button-border-color.png')} width="100%"/>
  </div>
);

export const PersonalityQuizResultTypeToolTip = (props) => (
  <div>
    If Single result is selected, this will function as a standard personality quiz displaying one result.  If multiple results are selected, multiple results will display in list form.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/6.CMS-PersonalityQuiz-single-select.png')} width="100%"/>
    <br/>
    <img src={makeToolTipUrl('personality-quiz/7.CMS-PersonalityQuiz-list-of-result.png')} width="100%"/>
  </div>
);

export const PersonalityQuizListResultHeadlineToolTip = (props) => (
  <div>
    The title of the results featured on the headline bar.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/8.CMS-PersonalityQuiz-list-result-headline.png')} width="100%"/>
  </div>
);

export const PersonalityQuizResultDescriptionToolTip = (props) => (
  <div>
    Copy elaborating on the result.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/9.CMS-PersonalityQuiz-list-result-desc-copy.png')} width="100%"/>
  </div>
);

export const PersonalityQuizQuestionTypeToolTip = (props) => (
  <div>
    If text is selected, text will appear over an image.  If image is selected, an image will appear with no field for text (text must be included in the image)
    <br/>
    <img src={makeToolTipUrl('personality-quiz/10.CMS-PersonalityQuiz-question-type-img.png')} width="100%"/>
    <br/>
    <img src={makeToolTipUrl('personality-quiz/11.CMS-PersonalityQuiz-question-type-text.png')} width="100%"/>
  </div>
);

export const PersonalityQuizQuestionToolTip = (props) => (
  <div>
    A question or prompt.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/12.CMS-PersonalityQuiz-question.png')} width="100%"/>
  </div>
);

export const PersonalityQuizQuestionImageToolTip = (props) => (
  <div>
    Image that relates to the question.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/13.CMS-PersonalityQuiz-question-img.png')} width="100%"/>
  </div>
);

export const PersonalityQuizQuestionShowOverlayToolTip = (props) => (
  <div>
    An opaque dark color will appear over the image to allow the question to be readable.
  </div>
);

export const PersonalityQuizAnswerTypeToolTip = (props) => (
  <div>
    If text is selected, text will appear in the answer button.  If image is selected, an image will appear as the answer button.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/14.CMS-PersonalityQuiz-answer-type-text.png')} width="100%"/>
    <br/>
    <img src={makeToolTipUrl('personality-quiz/15.CMS-PersonalityQuiz-answer-type-img.png')} width="100%"/>
  </div>
);

export const PersonalityQuizAnswerToolTip = (props) => (
  <div>
    The copy that appears in the answer button under the question.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/16.CMS-PersonalityQuiz-answer.png')} width="100%"/>
  </div>
);

export const PersonalityQuizAnswerImageToolTip = (props) => (
  <div>
    An image that appears under the question.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/17.CMS-PersonalityQuiz-answer-img.png')} width="100%"/>
  </div>
);

export const PersonalityQuizConnectedResultToolTip = (props) => (
  <div>
    The result that this answer is connected to.
  </div>
);

export const PersonalityQuizAnswerEditButtonColorsToolTip = (props) => (
  <div>
    Customize the color on the quiz answer buttons.
  </div>
);

export const PersonalityQuizAnswerButtonBackgroundColorToolTip = (props) => (
  <div>
    Customize the color of the text on the quiz answer buttons.
  </div>
);

export const PersonalityQuizResultTitleToolTip = (props) => (
  <div>
    The name of the result. Do not put URLs/Links in this field (superscript is acceptable).
    <br/>
    <img src={makeToolTipUrl('personality-quiz/18.CMS-PersonalityQuiz-result-title.png')} width="100%"/>
  </div>
);

export const PersonalityQuizResultImageToolTip = (props) => (
  <div>
    Image that describes the result.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/20.CMS-PersonalityQuiz-result-img.png')} width="100%"/>
  </div>
);

export const PersonalityQuizResultSocialShareImageToolTip = (props) => (
  <div>
    If yes, you can override the default "Facebook and social image."
  </div>
);

export const PersonalityQuizResultURLToolTip = (props) => (
  <div>
    A URL to direct the user to a location off site based on results served.
  </div>
);

export const PersonalityQuizResultURLTextToolTip = (props) => (
  <div>
    Call to action copy that will direct users to the Result URL link.
    <br/>
    <img src={makeToolTipUrl('personality-quiz/21.CMS-PersonalityQuiz-result-URL-text.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/personality-quiz-tool-tips.jsx